import React from 'react';
import MeterProductPage from '../meter-product-page';

import bgImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_background.png';
import logoImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_logo_white.png';
import qrImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_qr_code.jpg';
import productImg from '../../../assets/product-interaction/joys550/joys550_product.png';

const JOYS550 = () => (
  <MeterProductPage
    documentTitle="JOYS550｜智能远传水表"
    bgImg={bgImg}
    logoImg={logoImg}
    productImg={productImg}
    productImageStyle={{ width: '900px', height: '760px', left: '48px', top: '10px' }}
    qrImg={qrImg}
    model="JOYS550"
    productName="智能远传水表"
    slogan="精准计量 · 稳定远传"
    tags={['M-Bus', '4G', 'LoRa']}
    manualUrl="http://m.joymeter.com/manual?code=JOYS550-700-001"
    wiringUrl="/product/joys550/installation"
    secondaryTitle="查看安装说明"
    secondarySubtitle="INSTALLATION · 点击查看 →"
    secondaryLinkTitle="查看 JOYS550 安装与接线说明"
  />
);

export default JOYS550;
